import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import { ShowToastError, ShowToastSucess } from '../../components/toast/Toast';
import Header from '../Home/Header';
import DateFormat from '../../utils/DateFormat';
import Session from '../../utils/Session';
import UrlValidate from '../../utils/UrlValidate';
import RedirecionamentoSvc, { IRedirecionamentoRequest, IRedirecionamentosResponse } from '../../services/RedirecionamentoSvc';

function RedirecionamentoEdit() {
    let navigate = useNavigate();
    let { id } = useParams();
    const token = useRef(Session.getInfoToken());
    const idRef = useRef<string>(id ?? '');
    const isNovoRef = useRef(id === 'novo');
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [redirecionamento, setRedirecionamento] = useState<IRedirecionamentosResponse | null>(null);

    const [origem, setOrigem] = useState('');
    const [destino, setDestino] = useState('');

    async function salvarRedirecionamento() {
        try {
            if (origem === '') {
                return ShowToastError('Preencha o campo de origem');
            }

            UrlValidate.validate(origem);

            if (destino === '') {
                return ShowToastError('Preencha o campo de destino');
            }

            setSaving(true);
            const data: IRedirecionamentoRequest = {
                origem,
                destino,
                criadoPor: token.current?.email ?? '',
            };

            if (isNovoRef.current) {
                const response = await RedirecionamentoSvc.salvarRedirecionamento(data);
                isNovoRef.current = false;
                idRef.current = response.id;
                navigate(`/cadastroRedirecionamento/${response.id}`, {
                    replace: true,
                    state: null,
                });
            } else {
                const response = await RedirecionamentoSvc.alterarRedirecionamento(idRef.current, data);
                isNovoRef.current = false;
                idRef.current = response.id;
                navigate(`/cadastroRedirecionamento/${response.id}`, {
                    replace: true,
                    state: null,
                });
            }
            obterRedirecionamento();
            setSaving(false);
            ShowToastSucess('Redirecionamento salvo com sucesso!');
        } catch (error) {
            setSaving(false);
            if (!!error?.response) {
                ShowToastError(error?.response?.data?.error?.message);
            } else {
                ShowToastError(error?.message ?? 'Sem conexão com internet');
            }
        }
    }

    const obterRedirecionamento = useCallback(async () => {
        try {
            if (isNovoRef.current) {
                return;
            }
            setLoading(true);
            const response = await RedirecionamentoSvc.obterRedirecionamento(idRef.current);
            console.log(response);
            setRedirecionamento(response);
            setOrigem(response.origem);
            setDestino(response.destino);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            if (!!error?.response) {
                ShowToastError(error?.response?.data?.error?.message);
            } else {
                ShowToastError(error?.message ?? 'Sem conexão com internet');
            }
        }
    }, []);

    useEffect(() => {
        obterRedirecionamento();
    }, [obterRedirecionamento]);

    return (
        <>
            <Header />
            <div className="box-page" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <div className="box-page-header">
                    <h2 className="text-page-title text-white">
                        {isNovoRef.current ? 'Novo redirecionamento' : `Editar redirecionamento: ${idRef.current}`}
                    </h2>
                </div>
                <div
                    className="box-page-content"
                    style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
                >
                    {saving && (
                        <div className="flex-center">
                            <div className="spinner-border text-light" role="status" style={{ marginRight: 10 }} />
                        </div>
                    )}
                    {loading ? (
                        <div className="flex-center">
                            <div className="spinner-border text-light" role="status" style={{ marginRight: 10 }} />
                        </div>
                    ) : (
                        <Form
                            className="col-sm-6"
                            onSubmit={(e) => {
                                e.preventDefault();
                                salvarRedirecionamento();
                            }}
                        >
                            {!!redirecionamento && (
                                <>
                                    <h5 className="text-white">Criado por: {redirecionamento.criadoPor}</h5>
                                    <h5 className="text-white">Criado em: {DateFormat.formatarDataHora(redirecionamento.criadoEm)}</h5>
                                    <br />
                                </>
                            )}

                            <Form.Group className="mb-3" controlId="nome">
                                <Form.Label>*Origem</Form.Label>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text>/</InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        placeholder="Exemplo: conexaocalvary"
                                        value={origem}
                                        onChange={(e) => setOrigem(e.target.value.trim())}
                                    />
                                </InputGroup>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="nome">
                                <Form.Label>*Destino</Form.Label>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text>/</InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        placeholder="Exemplo: https://www.youtube.com/@calvarycampo"
                                        value={destino}
                                        onChange={(e) => setDestino(e.target.value.trim())}
                                    />
                                </InputGroup>
                            </Form.Group>

                            <br />
                            <Button variant="primary" type="submit">
                                Salvar
                            </Button>
                        </Form>
                    )}
                </div>
                <br />
                <br />
                <br />
            </div>
        </>
    );
}

export default RedirecionamentoEdit;
